export interface TeachingStyle {
  title: string;
  desc: string;
}

export interface TutorData {
  slug: string;
  imageSrc: string;
  title: string;
  subtitle: string;
  desc: string;
  rating: string;
  tags: string[];
  experience: string;
  students: string;
  languages: string[];
  bio: string;
  teachingStyle: TeachingStyle[];
  videoThumbnail: string;
}

export const programData: TutorData[] = [
  {
    slug: "ida-fitriyah",
    imageSrc: "/Mentor/Ida.jpeg",
    title: "Ida Fitriyah",
    subtitle: "Business Language Specialist",
    desc: "Universitas Sebelas Maret - Pendidikan Bahasa Indonesia",
    rating: "5.0",
    tags: ["Business", "Beginner"],
    experience: "8+ years",
    students: "1,200+",
    languages: ["Indonesian", "English"],
    bio: `Selamat datang! I am Ida Fitriyah, a native Indonesian speaker with over 8 years of dedicated experience teaching Bahasa Indonesia to expatriates, diplomats, and corporate professionals across Jakarta. My mission is to bridge the gap between textbook knowledge and real-world cultural fluency. I specialize in corporate communication and negotiation Indonesian for global trade. Whether you're navigating a boardroom in Sudirman or a market in Yogyakarta, I help you speak with confidence and soul.`,
    teachingStyle: [
      {
        title: "Conversational Focus",
        desc: "Heavy emphasis on dialogue from day one.",
      },
      {
        title: "Cultural Context",
        desc: 'Learning the "Why" behind Indonesian etiquette.',
      },
      {
        title: "Interactive Materials",
        desc: "Custom visual aids and modern slang insights.",
      },
    ],
    videoThumbnail: "",
  },
  {
    slug: "dian-rachmatika",
    imageSrc: "/Mentor/Dira.jpeg",
    title: "Dian Rachmatika",
    subtitle: "Business Language Specialist",
    desc: "University of Southampton, UK - English Language Teaching",
    rating: "5.0",
    tags: ["Business", "Beginner"],
    experience: "8+ years",
    students: "1,200+",
    languages: ["Indonesian", "English"],
    bio: `Selamat datang! I am Dian Rachmatika, a native Indonesian speaker with over 8 years of dedicated experience teaching Bahasa Indonesia to expatriates, diplomats, and corporate professionals across Jakarta. My mission is to bridge the gap between textbook knowledge and real-world cultural fluency. I specialize in corporate communication and negotiation Indonesian for global trade. Whether you're navigating a boardroom in Sudirman or a market in Yogyakarta, I help you speak with confidence and soul.`,
    teachingStyle: [
      {
        title: "Conversational Focus",
        desc: "Heavy emphasis on dialogue from day one.",
      },
      {
        title: "Cultural Context",
        desc: 'Learning the "Why" behind Indonesian etiquette.',
      },
      {
        title: "Interactive Materials",
        desc: "Custom visual aids and modern slang insights.",
      },
    ],
    videoThumbnail: "",
  },
];
